var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const breakpoints = {
  xs: 360,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1280
};
const breakpointQueries = Object.fromEntries(Object.entries(breakpoints).map(([key, val]) => [key, `@media screen and (min-width: ${val}px)`]));
const sharedThemeProperties = {
  animation: {
    duration: {
      150: "150ms",
      200: "200ms",
      300: "300ms"
    },
    timingFn: {
      /**
       * This pretends to be signature timing fn
       */
      drawer: "cubic-bezier(0,.75,.6,.75)",
      easeIn: "cubic-bezier(.8, .2, .6, 1)",
      // NOTE: value taken from nexus ui lib ButtonLink, not sure if it is ease
      ease: "cubic-bezier(0.445, 0.005, 0.18, 0.995)"
    }
  },
  breakpoints,
  fontSizes: {
    11: "11px",
    12: "12px",
    14: "14px",
    16: "16px",
    18: "18px",
    20: "20px",
    22: "22px",
    24: "24px",
    26: "26px",
    28: "28px",
    30: "30px",
    32: "32px",
    34: "34px",
    36: "36px",
    38: "38px",
    40: "40px"
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700
  },
  lineHeights: {
    1: "1",
    12: "12px",
    14: "14px",
    16: "16px",
    18: "18px",
    20: "20px",
    22: "22px",
    24: "24px",
    26: "26px",
    34: "34px",
    42: "42px"
  },
  mediaQuery: __spreadProps(__spreadValues({}, breakpointQueries), {
    touch: "@media (hover: none)",
    hover: "@media (hover: hover)"
  }),
  platform: void 0,
  radii: {
    0: "0",
    2: "2px",
    4: "4px",
    12: "12px"
  },
  shadow: {
    4: "0 1px 4px hsla(0, 0%, 0%, 0.16)",
    8: "0 2px 8px hsla(0, 0%, 0%, 0.16)",
    16: "0 4px 16px hsla(0, 0%, 0%, 0.16)"
  },
  space: {
    0: "0",
    2: "2px",
    4: "4px",
    6: "6px",
    8: "8px",
    10: "10px",
    12: "12px",
    14: "14px",
    16: "16px",
    18: "18px",
    20: "20px",
    22: "22px",
    24: "24px",
    26: "26px",
    28: "28px",
    30: "30px",
    32: "32px",
    36: "36px",
    38: "38px",
    40: "40px",
    48: "48px",
    56: "56px",
    64: "64px"
  },
  zIndices: {
    dropdown: 1e3,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070
  }
};

export { sharedThemeProperties };
